export default "__VITE_PUBLIC_ASSET__a072b453__"